// src/models/api/voice.ts
import { postRequest } from './rest'

export type EnableVoiceParams = {
  admin_email: string
  admin_name: string
  admin_password?: string
  admin_phone?: string
  company: string
  subdomain: string
}

/**
 * POST /api/v5/orgs/{id}/enable_voice
 * Enables voice (Zello) for an org.
 *
 * IMPORTANT: once set, these settings are immutable.
 */
export const enableVoiceForOrg = async (orgId: string, params: EnableVoiceParams): Promise<any> => {
  const res = await postRequest({
    endpoint: `api/v5/orgs/${orgId}/enable_voice`,
    data: params,
  })

  // Match the pattern used in licenses.ts (tolerate either { data: ... } or plain object)
  return res?.data?.data ?? res?.data
}

/**
 * POST /api/v5/orgs/{id}/enable_voice with `backend: fleet`.
 * Points the org at the React Mobile Voice Service. The API refuses it once
 * Zello has been started for the org, and offers no way back.
 */
export const enableFleetVoiceForOrg = async (orgId: string): Promise<any> => {
  const res = await postRequest({
    endpoint: `api/v5/orgs/${orgId}/enable_voice`,
    data: { backend: 'fleet' },
  })
  return res?.data?.data ?? res?.data
}

/**
 * POST /api/v5/orgs/{id}/disable_voice
 * Takes the org off the React Mobile Voice Service, leaving it with no voice.
 * Its channels and licenses are kept for when the service is turned back on.
 */
export const disableFleetVoiceForOrg = async (orgId: string): Promise<any> => {
  const res = await postRequest({ endpoint: `api/v5/orgs/${orgId}/disable_voice`, data: {} })
  return res?.data?.data ?? res?.data
}
